import {
  alpha,
  Avatar,
  Box,
  CardContent,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';

import CommonDashboardCard from "../commonDashboardCard"
import Sparkline from "../sparkline"

import CustomIcon from 'src/components/custom-icon';

export default function MetricCard({
  id,
  title,
  value,
  percentage,
  color,
  icon,
  chartData,
  onClick,
  msgRedirect
}) {

  function handleClick() {
    if (!!msgRedirect)
      onClick?.()
  }

  return (
    <CommonDashboardCard>
      <CardContent
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center"
        }}
      >
        <Tooltip
          title={msgRedirect || title}
          placement='top'
          sx={{
            cursor: !!msgRedirect ? "pointer" : "default"
          }}
          onClick={handleClick}
        >
          <Stack
            direction="row"
            spacing={2}
            alignItems="flex-start"
            justifyContent="center"
          >
            <Avatar
              sx={{
                width: 46,
                height: 46,
                color,
                '&&&&': {
                  background: `${alpha(color, 0.25)} !important`
                },
              }}
            >
              <CustomIcon icon={icon} color={color} iconSx={{ fontSize: "2rem" }} />
            </Avatar>

            <Box sx={{
              display: "flex",
              flexDirection: "column",
              minWidth: 0,
              flex: 1,
              gap: "0.5rem"
            }}>

              <Typography
                variant="h6"
                fontWeight="bold"
                sx={{
                  fontSize: ".9rem",
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {title}
              </Typography>

              <Typography
                variant="h6"
                fontWeight="bold"
                sx={{
                  color,
                  fontSize: "1.8rem",
                }}
              >
                {value}
              </Typography>

              <Typography
                variant="caption"
                sx={{
                  fontSize: ".8rem",
                }}
              >
                {percentage}
              </Typography>
            </Box>
          </Stack>
        </Tooltip>

        {(chartData ?? []).length > 0 &&
          <Box sx={{ mt: 0.5 }}>
            <Sparkline
              data={chartData}
              color={color}
              height={42}
              gradientId={`metric-gradient-${id}`}
            />
          </Box>
        }
      </CardContent>
    </CommonDashboardCard>
  );
}
